import axios from "axios";
import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

export default function (ComposedComponent) {
	function Authenticate(props) {
		if (!(props.loginSuccesful === "succesful")) {
			return <Redirect to="/" />; // denk over forbidden na: 401 unauthorized
		} else {
			axios.defaults.headers.common["Token"] = props.token;
			axios.defaults.headers.common["Authorization"] = props.authorization;
			return <ComposedComponent {...props} />;
		}
	}

	function mapStateToProps(state) {
		return {
			loginSuccesful: state.login.data.loginSuccesful,
			token: state.login.data.token,
			authorization: state.login.data.authorization,
		};
	}

	return connect(mapStateToProps)(Authenticate);
}
//  TODO requirePermission
